import { render, staticRenderFns } from "./settlement-price-setting.vue?vue&type=template&id=3fcaf63a&scoped=true&"
import script from "./settlement-price-setting.vue?vue&type=script&lang=js&"
export * from "./settlement-price-setting.vue?vue&type=script&lang=js&"
import style0 from "./settlement-price-setting.vue?vue&type=style&index=0&id=3fcaf63a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcaf63a",
  null
  
)

export default component.exports